export default __webpack_public_path__ + "static/media/home-creative-agency-img-03.a33ce047.jpg";